import WebManagerRouter from "@/router/web/manager";

const WebRouter = [
    {
        path: '/',
        redirect: () => {
            return '/digitize'
        }
    },
    {
        path: '/login',
        component: () =>
            import ('../views/web/login'),
        meta: {
            title: '登录',
            needLogin: false, // 是否需要登录才能访问
            isLogin: true // 是否需要登录才能访问
        }
    },
    {
        path: '/digitize',
        component: () =>
            import ('../views/web/manager/digitize'),
        meta: {
            title: '社会组织党务管理系统',
            needLogin: true, // 是否需要登录才能访问
        }
    },
    //  管理
    {
        path: '/manager',
        component: () =>
            import ('../views/web/home'),
        children: WebManagerRouter,
    },

]
export default WebRouter